'use strict';

require('./selectors.cjs');

"use strict";
//# sourceMappingURL=index.cjs.map
